import React from 'react';
import PropTypes from 'prop-types';

const PlayerTextArea = ({ answer} ) => {
  return (
    <div className='o-player-cell u-wspace--prewrap'>
      { answer ? answer.textAnswer : <span>&mdash;</span> }
    </div>
  );
}

PlayerTextArea.propTypes = {
  responseType: PropTypes.object.isRequired,
  answer: PropTypes.object,
}

export default PlayerTextArea;
